// extracted by mini-css-extract-plugin
export default {"header":"Header_header__409gs","loginBlock":"Header_loginBlock__mbA9R"};